import classNames from 'classnames/bind';
import FormCheckbox from './_checkbox';
import styles from './form.module.scss';
import { FormSelectInputProps } from './_select';
import Spinner from '../spinner/spinner';
import { getValue } from './_text-input';
import { castArray } from 'lodash';

const classesContext = classNames.bind(styles);

export default function FormMultiSelect<T>({
  className,
  formik,
  name,
  options,
  isLoading
}: FormSelectInputProps<T>): JSX.Element {
  const values = castArray(getValue(formik, name))
    .map((item) => item.toString());

  return (
    <div className={classesContext(['multiselect', className])}>
      <div className={styles.multiselect_scroll}>
        {options?.map((item) => (
          <FormCheckbox<T>
            formik={formik}
            key={item.value}
            name={name}
            value={item.value.toString()}
            checked={values?.includes(item.value.toString())}
            className={styles.multiselect_item}
          >
            {item.label}
          </FormCheckbox>
        ))}
      </div>
      {isLoading && (
        <span className={styles.multiselect_spinner}>
          <Spinner />
        </span>
      )}
    </div>
  );
}
